export const CANCEL_KEY = 'cancel';
export const CROP_KEY = 'crop';
export const CROPPING_NOT_SUPPORTED_KEY = 'croppingNotSupported';
export const OPTIONS_KEY = 'options';
export const PREVIEW_KEY = 'preview';
